import { render, staticRenderFns } from "./TheGroupModalMembers.vue?vue&type=template&id=38b96b7c&scoped=true"
import script from "./TheGroupModalMembers.vue?vue&type=script&lang=js"
export * from "./TheGroupModalMembers.vue?vue&type=script&lang=js"
import style0 from "./TheGroupModalMembers.vue?vue&type=style&index=0&id=38b96b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b96b7c",
  null
  
)

export default component.exports